import { call, put } from 'typed-redux-saga';

import {
    DTMF_COMMANDS,
    dtmfCloseParticipantListSaga,
    dtmfOpenParticipantListSaga,
    dtmfParticipantListChangePageSaga,
} from '../dtmf-commands';
import { BaseState } from './base-state';
import { StateId } from './types';

const PARTICIPANT_LIST_STATE_TRANSITIONS: Record<string, StateId> = {
    [DTMF_COMMANDS.common.close]: 'idle',
};

export class ParticipantListState extends BaseState {
    public id: StateId = 'participant-list';

    public *process(command: string) {
        if (command === DTMF_COMMANDS.participantList.prevPage || command === DTMF_COMMANDS.participantList.nextPage) {
            yield* call(dtmfParticipantListChangePageSaga, command);
        }

        if (PARTICIPANT_LIST_STATE_TRANSITIONS[command]) {
            yield* put(this.context.requestTransitionChannel, PARTICIPANT_LIST_STATE_TRANSITIONS[command]);
        }
    }

    public *onEnter() {
        yield* call(dtmfOpenParticipantListSaga);
    }

    public *onExit() {
        yield* call(dtmfCloseParticipantListSaga);
    }
}
